import { DPR } from '@frameio/utils';
import { Avatar, Chip as VaporChip, hexToColorToken } from '@frameio/vapor';
import { isThemeMetaColor } from '../../../../utils';
import { getAvatarResizedURL } from '../../../../utils/getAvatarResizedURL';
import type { ChipFragment } from '../../gql/generated/LayoutItems';

const chipStyle = { marginTop: '6px', marginBottom: '6px', cursor: 'pointer' };

export const CHIP_AVATAR_SIZE = 20 * DPR;

export function Chip({ layoutItem }: { layoutItem: ChipFragment }) {
  const src = layoutItem?.avatar?.url
    ? getAvatarResizedURL(layoutItem.avatar.url, CHIP_AVATAR_SIZE)
    : undefined;

  const chipColorHex =
    'color' in layoutItem.style ? layoutItem.style.color : 'default';

  const chipColorToken =
    chipColorHex && isThemeMetaColor(hexToColorToken[chipColorHex])
      ? hexToColorToken[chipColorHex]
      : 'default';

  const avatarBackgroundColor =
    layoutItem.avatar && 'color' in layoutItem.avatar
      ? layoutItem.avatar.color?.toLowerCase()
      : 'default';

  const backgroundColor = isThemeMetaColor(avatarBackgroundColor)
    ? avatarBackgroundColor
    : 'default';

  const ChipAvatar = layoutItem?.avatar && (
    <Avatar
      alt={layoutItem?.avatar?.userName}
      background={backgroundColor}
      src={src}
    />
  );

  return (
    <VaporChip
      avatar={ChipAvatar}
      color={chipColorToken}
      data-testid={'notification-chip'}
      style={chipStyle}
    >
      {layoutItem.content}
    </VaporChip>
  );
}
